import { Box, Heading, Container } from "@chakra-ui/react"
import styles from './mystyle.module.css';
import logo from './zigridLogo.jpg'
import React from 'react';
import { Slide } from 'react-slideshow-image';
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import img0 from './images/Surgery.jpg'	
import img1 from './images/01.jpg'
	import img2 from './images/02.jpg'
	import img3 from './images/03.jpg'	
	
const slideImages = [
  'images/01.jpg',
  'images/02.jpg',
  'images/03.jpg'
];
const Slider = ({...props}) => {
    return	 	<center> 
		<Box w="60%"  {...props}  >
	        	<Heading  textAlign="center"
	            		py="2%"
	            		as="h2" 
	            		size="4xl"
	            		color="rgba(0,0,0,0.7)"
			            userSelect="none"
			            fontWeight="700"
			            letterSpacing="0.099em"   >
							<div>			
					          <div className="slide-container" >
										<Fade>
												<div className="each-fade">
									 				<div style={{'backgroundImage': `url(${slideImages[0]})`}}>
 														<center>
															<img src={img1} className={styles.responsive2} />
														</center>
													</div>
												</div>
							        
									          <div className="each-fade">
													<center>
									        			<img  src={img2} className={styles.responsive2} />
													</center>
									          </div>
											
									          <div className="each-fade">
													<center>
									        			<img  src={img3} className={styles.responsive2} />
													</center>
									          </div>
									          <div className="each-fade">
									        			<img  	src={img0} className={styles.responsive3} />
									          </div>														
							       		</Fade>
					      		</div>
 						</div>
	        	</Heading>
    		</Box>
														</center>
														 
}
export default Slider